import { gql } from "gql";

export const SAVE_DYNAMIC_PROCESS_MODEL = gql(/* GraphQL */ `
  mutation SaveDynamicProcessModel($process: DynamicProcessInput!) {
    saveDynamicProcessModel(process: $process) {
      id
    }
  }
`);
